import { FC, ReactNode } from 'react'
import { RadioGroup, RadioGroupProps, StackProps, VStack } from '@chakra-ui/react'
import { useField, useFormikContext } from 'formik'

import FormControl, { BaseProps } from '../FormControl'

type RadioGroupControlProps = BaseProps & {
  radioGroupProps?: RadioGroupProps;
  stackProps?: StackProps;
  children: ReactNode;
}

const RadioControl: FC<RadioGroupControlProps> = ({ children, name, label, radioGroupProps, stackProps, ...rest }) => {
  const [field] = useField(name)
  const { setFieldValue } = useFormikContext()
  const handleChange = (value: string) => {
    setFieldValue(name, value)
  }

  return (
    <FormControl name={name} label={label} {...rest}>
      <RadioGroup {...field} onChange={handleChange} {...radioGroupProps}>
        <VStack  {...stackProps}>
          {children}
        </VStack>
      </RadioGroup>
    </FormControl>
  )
}

export default RadioControl
